import { AccessRequest } from '@/interfaces/accessRequest.interface';
import { ApiResponse } from '@/interfaces/apiresponse.interface';
import { EngagementResponse } from '@/interfaces/engagementResponse.interface';
import { AppNav } from '@/routes/app-nav';
import { EngagementAccessService } from '@/services/engagement-access.service';
import { TitleService } from '@/services/title.service';
import Helpers from '@/shared/helpers';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-manage-engagements-page',
  standalone: false,
  templateUrl: './manage-engagements-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./manage-engagements-page.component.scss']
})
export class ManageEngagementsPageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  private helpers: Helpers;

  messageKey: string = "engagementPage";
  engagementEntries: EngagementResponse[] = [];
  loading: boolean = false;
  showingAccessManagement: boolean = false;
  selectedEngagement?: EngagementResponse;

  @ViewChild(Table) engagementEntryTable!: Table;

  constructor(
    private titleService: TitleService,
    private translocoService: TranslocoService,
    private messageService: MessageService,
    private engagementAccessService: EngagementAccessService,
  ) {
    this.helpers = Helpers.getInstance(this.translocoService);
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppNav.StatusMonitor.title);
    this.loadRequestEntries();
  };

  loadRequestEntries(): void {
    this.loading = true;
    this.engagementAccessService.managedEngagements()
      .then(
        (response: HttpResponse<ApiResponse>) => {
          this.loading = false;
          const entries = (response.body || []) as EngagementResponse[];
          this.engagementEntries = entries;
        },
        (response: HttpErrorResponse) => {
          this.loading = false;
          this.helpers.showApiResponseMessage(response, this.messageService, this.messageKey);
        }
      );
  }

  showAccessManagement(engagement: EngagementResponse){
    this.showingAccessManagement = true;
    this.selectedEngagement = engagement;
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}
